export const getInitialState = () => ({
  confirmBottomDialog: {
    isShown: false,
    ctaPrimaryLabel: '',
    message: '',
  },
  notificationStatus: {
    isShown: false,
    message: '',
  },
  activeBlock: null,
  selectedTab: 1,
  modalTooltip: {
    widgetId: null,
    selectedPage: 0,
  },
});
